import uuidv5 from 'uuid/v5';
import btoa from 'btoa';
import { trim, encode } from 'url-safe-base64';
import { createSelector } from 'reselect';
import { selectMap } from './base';
import { CDN, TILESERVER } from '../../../config';

const { URL, location } = window;
const PROD_HOST = 'scstg.herokuapp.com';
const missingProtocol = /^\/\//;

export const selectGeoJSONURL = createSelector(
  createSelector(selectMap, map => map.url),
  (urlString) => {
    try {
      const url = missingProtocol.test(urlString)
        ? new URL(`${location.protocol}${urlString}`)
        : new URL(urlString);

      if (url.host === PROD_HOST) {
        url.protocol = 'https:';
      }

      return url;
    } catch (err) {
      return null;
    }
  },
);

export const selectEncodedGeoJSONURL = createSelector(
  selectGeoJSONURL,
  url => url && trim(encode(btoa(url))),
);

export const selectGeoJSONUUID = createSelector(
  selectGeoJSONURL,
  url => url && url.host === PROD_HOST && uuidv5(url.toString(), uuidv5.URL),
);

export const selectCachedTileJSONURL = createSelector(
  selectGeoJSONUUID,
  uuid => uuid && `${CDN}/maps/${uuid}/tile.json`,
);

export const selectDynamicTileJSONURL = createSelector(
  selectEncodedGeoJSONURL,
  url => url && `${TILESERVER}/${url}/tile.json`,
);

export const selectTileJSONCacheUpdaterURL = createSelector(
  selectGeoJSONUUID,
  selectEncodedGeoJSONURL,
  (uuid, url) => uuid && url && `${TILESERVER}/${url}/update`,
);



// WEBPACK FOOTER //
// ./src/modules/map/selectors/urls.js